import { TopicType } from '@api';
import { getTimeTillEndOfDayMs } from '@helpers';
import { useQuery } from '@tanstack/react-query';
import { getTopics } from '@terminal/services/topics/topics-service';

export const QUERY_KEY_FOLLOWED_TOPICS = 'QUERY_KEY_FOLLOWED_TOPICS';

export const useFollowedTopics = (type: TopicType, enabled: boolean) =>
  useQuery({
    queryKey: [QUERY_KEY_FOLLOWED_TOPICS, type],
    queryFn: ({ signal }) => getTopics(type, signal),
    staleTime: getTimeTillEndOfDayMs(),
    enabled,
  });
